import { render, staticRenderFns } from "./detention-case.vue?vue&type=template&id=6cd0185e"
import script from "./detention-case.vue?vue&type=script&lang=ts"
export * from "./detention-case.vue?vue&type=script&lang=ts"
import style0 from "./detention-case.vue?vue&type=style&index=0&id=6cd0185e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports